<!-- HTML Template -->
<template>
  <div v-if="is_open">
    <div class="confirmation-popup-overlay">
      <template v-if="view == 'popup'">
        <div class="confirmation-popup__cancel">
          <div class="d-flex justify-content-between">
            <h5>Cancel plan</h5>
            <a @click.prevent="closePopup()" class="button-close">
              <img src="/img/close.svg" alt="close" class="close-icon">
            </a>
          </div>
          <p class="text-secondary confirmation-popup__cancel__text">If you with to cancel your subscription, the existing {{ plan_name }} plan will be available to you until the end of your billing cycle, {{ active_until }}.</p>

          <div class="d-flex">
            <button class="ml-auto button button-m button-primary" @click="showReason()">Continue</button>
          </div>
        </div>
      </template>
      <template v-else-if="view == 'reason'">
        <div class="confirmation-popup__cancel">
          <div class="d-flex justify-content-between">
            <h5>Sorry to see you go</h5>
            <a @click.prevent="!spin.pressed_cancel ? closePopup() : ''" class="button-close">
              <img src="/img/close.svg" alt="close" class="close-icon">
            </a>
          </div>
          <p class="text-secondary confirmation-popup__cancel__text">Could you tell us why you decided to cancel?</p>

          <div>
            <a-radio-group v-model="value" :disabled="spin.pressed_cancel">
              <a-radio value="It didn’t provide enough value for me" :style="radioStyle"><span class="text-secondary">It didn’t provide enough value for me</span></a-radio>
              <a-radio value="I plan to use another product instead" :style="radioStyle"><span class="text-secondary">I plan to use another product instead</span></a-radio>
              <a-radio value="I didn’t like the product" :style="radioStyle"><span class="text-secondary">I didn’t like the product</span></a-radio>
              <a-radio value="4" :style="radioStyle"><span class="text-secondary">Other (please specify)</span></a-radio>
            </a-radio-group>
          </div>

          <div class="input-group">
            <textarea class="input textarea" placeholder="Please enter any additional comments you have about us to do better next time" v-model="reason"></textarea>
          </div>
        
          <div class="d-flex">
            <div class="ml-auto">
            <a-spin :spinning="spin.pressed_cancel">
            <button :disabled="!value || (value==4&&!reason)" class="button button-m button-primary" @click="cancelPlan()">Continue</button>
            </a-spin>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="view == 'confirmed'">
        <div class="confirmation-popup__cancel">
          <div class="d-flex justify-content-between">
            <h5>Plan cancelled</h5>
            <a @click.prevent="closePopup()" class="button-close">
              <img src="/img/close.svg" alt="close" class="close-icon">
            </a>
          </div>
          <p class="text-secondary confirmation-popup__cancel__text">Your Starter plan has been cancelled. You will have full access to your account until {{ active_until }}. Any published listings you had will be removed on the same day</p>

          <div class="d-flex">
            <button class="ml-auto button button-m button-primary" @click="closePopup()">Done</button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<!-- Javascript -->
<script>
  const CANCEL_POPUP = 'popup';
  const CANCEL_REASON = 'reason';
  const CANCEL_CONFIRMED = 'confirmed';

  export default {
    props: {
      active_until: String,
      plan_name: String
    },
    data() {
        return {
          spin: {
            pressed_cancel: false,
          },
          is_open: false,
          view: CANCEL_POPUP,
          value: "",
          reason: "",
          radioStyle: {
            display: 'block',
            marginBottom: '12px',
            fontSize: '16px'
          },
        }
    },
    computed: {

    },
    mounted() {
        console.log('Component mounted.')
    },
    created() {
    },
    methods: {
      cancelPlan() {
        this.spin.pressed_cancel = true;
        let reason = this.value != 4 ? this.value + '. ' + this.reason : this.reason;
        this.$root.$emit('cancel_plan_confirmed', CANCEL_SUBSCRIPTION, reason);
      },
      showReason() {
        this.view = CANCEL_REASON;
      },
      closePopup() {
        this.is_open = false;
        this.view = CANCEL_POPUP;
      }
    }
  }
</script>